@import 'styles/mixins';

.intro {
  @include ui-sm-text;
  text-align: center;
}

.content {
  padding: 0 16px;
}

.profileCardContainer {
  margin-bottom: 29px;
}
